import styles from "@/styles/components/Spinner.module.css"

/**
 * A write in flight, inside the button that started it.
 *
 * Drawn in `currentColor`, so one component works on the primary fill, on a
 * quiet outline and on a 24px icon button without a variant for each — the
 * button's own colour is already the right one.
 *
 * Decorative on purpose: the button carries `aria-busy`, which is what a screen
 * reader announces. A spinner that also announced itself would say it twice.
 */
interface SpinnerProps {
  /** `sm` for the icon buttons, where `md` would fill the whole circle. */
  size?: "sm" | "md" | "lg"
  className?: string
}

export default function Spinner({ size = "md", className }: SpinnerProps) {
  const classes = [styles.spinner, styles[size], className].filter(Boolean).join(" ")
  return <span className={classes} aria-hidden="true" />
}
